import { render } from "./DraftView.vue?vue&type=template&id=eb1c4508"
import script from "./DraftView.vue?vue&type=script&lang=js"
export * from "./DraftView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__